import { CreateCategoryDTO, SortCategoryDTO, UpdateCategoryDTO } from "../models/categories/categories.request";
import { ApiResponse } from "../models/base/ApiResponse";
import { api } from "../api/api";
import { CategorySelectDto, CategorySettingsInfoDto, CategorySettingsItemDto } from "../models/categories/categories.response";


export const categoriesService = {

    async createCategory(dto: CreateCategoryDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>('/categories', dto);
        return data;
    },

    async getSettingsCategories(localId: string): Promise<ApiResponse<CategorySettingsItemDto[]>> {
        const { data } = await api.get<ApiResponse<CategorySettingsItemDto[]>>(`/locals/${localId}/categories/settings`);
        return data;
    },

    async updateCategory(id: string, localId: string, dto: UpdateCategoryDTO): Promise<ApiResponse<string>> {
        const { data } = await api.put<ApiResponse<string>>(`/locals/${localId}/categories/${id}`, dto);
        return data;
    },

    async getCategoryById(localId: string, categoryId: string): Promise<ApiResponse<CategorySettingsInfoDto>> {
        const { data } = await api.get<ApiResponse<CategorySettingsInfoDto>>(`/locals/${localId}/categories/${categoryId}/settings`);
        return data;
    },

    async deleteCategory(localId: string, categoryId: string): Promise<ApiResponse<string>> {
        const { data } = await api.delete<ApiResponse<string>>(`/locals/${localId}/categories/${categoryId}`);
        return data;
    },

    async sortCategories(localId: string, dto: SortCategoryDTO): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${localId}/categories/sort`, dto);
        return data;
    },

    async getCategoriesSelect(localId: string): Promise<ApiResponse<CategorySelectDto[]>> {
        const { data } = await api.get<ApiResponse<CategorySelectDto[]>>(`/locals/${localId}/categories/select`);
        return data;
    }

};